<script>
    import { Input, Button } from 'svantic'
    import { sendChatMessage } from '../../scripts/stake-api'

    let i_chatMessage

    
	const handleSubmit = () => {
		if(i_chatMessage.length > 0){ 
			sendChatMessage("de", i_chatMessage);
			i_chatMessage = ""
		}
	}
</script>

<div class="input-container" >
    <form on:submit|preventDefault={ handleSubmit }>
        <Input action  type="text"   bind:value={i_chatMessage} fluid labeled="right" size="small">

            <Button icon="send" slots="right"></Button>
        </Input>
        
    </form>

</div>

<style>
    	
	.input-container {
		width: 100%;
		height: 42px;
		padding: 6px;
		background: #2185d0;
	}

</style>